import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { upload } from '../../api/sportaloka-client';
import clsx from 'clsx';

const Uploader = ({ label, path, value, onChange, isError, errorMessage, id, accept }) => {
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    e.target.value = '';
    if (selectedFile) {
      handleUpload(selectedFile);
    }
  };

  const handleUpload = async (file) => {
    if (!file) {
      Swal.fire({
        title: 'Gagal!',
        text: `Harap memilih file`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', path);

    try {
      setLoading(true);
      const response = await upload(formData);
      onChange(response.data.data.url);
      setLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba kembali`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setLoading(false);
    }
  };

  const handleRemove = () => {
    onChange('');
  };

  return (
    <div>
      <div className="uploader">
        <label htmlFor="">{label ? label : 'Upload file'}</label>
        <input
          type="text"
          readOnly
          className={clsx('form-control bg-light-2', { 'border-danger': isError })}
        />
        <input
          accept={accept ? accept : '*'}
          type="file"
          onChange={handleFileChange}
          style={{ display: 'none' }}
          id={id}
        />
        <button
          type="button"
          disabled={loading}
          className="uploader__trigger"
          onClick={() => document.getElementById(id).click()}>
          {!loading ? 'Upload' : 'Mengupload...'}
        </button>
      </div>
      {isError && errorMessage && (
        <span className="text-danger text-14 fw-normal">{errorMessage}</span>
      )}
      {value && !loading && (
        <div className="bg-light-2 rounded-lg mt-20 justify-content-center d-flex flex-column py-20 px-20">
          <img src={value} className="img-fluid mt-10" style={{ minHeight: 100 }} alt="" />
          <div className="text-center mt-20">
            <a
              href={value}
              target="_blank"
              rel="noreferrer"
              className="btn btn-sm btn-primary bg-blue-1 fw-500 mr-10">
              Tampilkan
            </a>
            <span onClick={handleRemove} className="btn btn-sm btn-danger fw-500">
              Hapus
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Uploader;
